// NPM
/* Load npm scripts here */
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

// VENDOR
/* Load vendor modules here */
import { trackEvent } from 'vendor/google/gtm/gtmEventTracker';

// HELPERS
/* Load helpers here */
import { withFocusManagement } from 'helpers/swiper/swiperFocusManagement';

// BUNDLES
/* Load bundles here */
import defaultBundle from 'bundles/default.bundle';

// HELPERS
/* Load helpers here */

// COMPONENTS
/* Load components here */
import ReadMore from 'components/readmore/readMore';
import { InlineWattageCalculator } from 'components/radiator-watt-calculator/radiator-watt-calculator';

// PAGE
/* load page specific scripts */

defaultBundle();

// Init read more button
ReadMore.init();

// Init category link block swiper
const productSliders = document.querySelectorAll('.product-swiper'); //Get all product sliders
if (productSliders) {
    const swiperConfig = withFocusManagement({
        modules: [Navigation],
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        spaceBetween: 16,
        slidesPerView: 1.5,
        breakpoints: {
            380: {
                slidesPerView: 2.5
            },
            769: {
                slidesPerView: 3
            },
            992: {
                slidesPerView: 4
            },
            1200: {
                slidesPerView: 5
            },
            1550: {
                slidesPerView: 6
            }
        }
    });

    // Loop through all sliders
    productSliders.forEach((el) => {
        const productSwiper = new Swiper(el, swiperConfig);

        // Get GTM data attributes
        const gtmCategory = el.dataset.gtmCategory;
        const gtmAction = el.dataset.gtmAction;
        const gtmLabel = el.dataset.gtmLabel;

        if (gtmCategory && gtmAction && gtmLabel) {
            // TrackEvent on slideChange
            productSwiper.on('slideChange', function () {
                trackEvent(gtmCategory, gtmAction, gtmLabel);
            });
        }
    });
}

// Wattage calculator
InlineWattageCalculator.init();
